import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import TimeClockLocationContainer from '../../containers/TimeClockLocation';
import FormSelect from '../form/FormSelect';

class CompanySelect extends PureComponent {
	componentDidMount() {
		const { timeClockLocations, searchLocations } = this.props;
		if (_.isEmpty(timeClockLocations)) {
			searchLocations();
		}
	}

	render() {
		const { timeClockLocations } = this.props;
		if (_.isEmpty(timeClockLocations)) {
			return <div>Fetching Companies...</div>;
		}

		const companyNames = _.sortBy(_.uniq(_.compact(_.map(timeClockLocations, 'companyName'))));
		const options = [
			{ value: '', display: 'All Companies' },
			...companyNames.map((companyName) => {
				return {
					value: companyName,
					display: companyName,
				};
			}),
		];

		return <FormSelect {...this.props} options={options} />;
	}
}

CompanySelect.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	classes: PropTypes.object,
	helpText: PropTypes.string,
	timeClockLocations: PropTypes.array,
};

CompanySelect.defaultProps = {
	label: 'Company',
	timeClockLocations: [],
};

export default TimeClockLocationContainer(CompanySelect);
